import { z } from 'zod';

import { makeEndpoint } from '../common';

export const SyncTransactionSummaryRequestSchema = z.object({
  entityType: z.enum(['brand', 'host']),
});

export const SyncTransactionSummaryResponseSchema = z.object({
  totalEarned: z.number(),
  futurePayout: z.number(),
});

export const SyncTransactionSummaryEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/dashboard-stats/transaction-summary/sync`,
  responseSchema: SyncTransactionSummaryResponseSchema,
  requestSchema: SyncTransactionSummaryRequestSchema,
});

export type SyncTransactionSummaryRequest = z.infer<typeof SyncTransactionSummaryRequestSchema>;
export type SyncTransactionSummaryResponse = z.infer<typeof SyncTransactionSummaryResponseSchema>;
